import { render } from "./DeliveryDatePicker.vue?vue&type=template&id=c2a485d4&ts=true"
import script from "./DeliveryDatePicker.vue?vue&type=script&lang=ts"
export * from "./DeliveryDatePicker.vue?vue&type=script&lang=ts"

import "./DeliveryDatePicker.vue?vue&type=style&index=0&id=c2a485d4&lang=css"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__